import React from "react";
import { Button, Modal, ModalFooter } from "@telluscompany/design-system";
import { useLocalization } from "@i18n";
import { LoadingBlurDiv } from "@shared/components";
import {
  AdminStructureAnmClassificationTab,
  type AdminStructureDamAnmClassification,
} from "@modules/admin";

import { useGeneralStructureAnmClassificationQuery } from "../../api/generalAnmClassification/generalAnmClassification.queries";

interface GeneralAnmClassificationModalProps {
  open: boolean;
  onClose: () => void;
  structureId: string | null;
}

export const GeneralAnmClassificationModal: React.FC<GeneralAnmClassificationModalProps> = ({
  open,
  onClose,
  structureId,
}) => {
  const { translate } = useLocalization();

  const { data, isFetching, isError } = useGeneralStructureAnmClassificationQuery(
    open && structureId ? structureId : undefined,
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translate("general.dashboard.anmClassification.modalTitle")}
      content={
        <LoadingBlurDiv isLoading={isFetching} className="general-dashboard-modal-scroll-shell">
          <div className="general-dashboard-modal-body general-dashboard-modal-body--classification">
            {isError && (
              <p className="mb-4 text-sm text-destructive">
                {translate("general.dashboard.loadError")}
              </p>
            )}

            {structureId ? (
              <AdminStructureAnmClassificationTab
                structureId={structureId}
                canWrite={false}
                externalClassification={{
                  data: data as AdminStructureDamAnmClassification | undefined,
                  isLoading: isFetching,
                }}
              />
            ) : null}
          </div>
          <ModalFooter
            footer={
              <Button type="button" variant="primary" onClick={onClose}>
                {translate("general.dashboard.button.close")}
              </Button>
            }
          />
        </LoadingBlurDiv>
      }
    />
  );
};
